export const cssPrefix = 'gl-'
export const varPrefix = 'gl-'

export const helperClasses = [
  'background-none',
  'background-color-transparent',
  'color-transparent',
  'background-color-primary',
  'color-primary',
  'background-color-success',
  'color-success',
  'background-color-info',
  'color-info',
  'background-color-warning',
  'color-warning',
  'background-color-error',
  'color-error',
  'background-color-text',
  'color-text',
  'background-color-text-invert',
  'color-text-invert',
  'background-color-text-light',
  'color-text-light',
  'background-color-text-disabled',
  'color-text-disabled',
  'background-color-text-strong',
  'color-text-strong',
  'background-color-black',
  'color-black',
  'background-color-grey-darker',
  'color-grey-darker',
  'background-color-grey-dark',
  'color-grey-dark',
  'background-color-grey',
  'color-grey',
  'background-color-grey-light',
  'color-grey-light',
  'background-color-grey-lighter',
  'color-grey-lighter',
  'background-color-white-ter',
  'color-white-ter',
  'background-color-white-bis',
  'color-white-bis',
  'background-color-white',
  'color-white',
  'background-color-medium-grey',
  'color-medium-grey',
  'flex-grow-0',
  'flex-grow-1',
  'flex-grow-2',
  'flex-grow-3',
  'flex-grow-4',
  'flex-grow-5',
  'flex-shrink-0',
  'flex-shrink-1',
  'flex-shrink-2',
  'flex-shrink-3',
  'flex-shrink-4',
  'flex-shrink-5',
  'flex-direction-row',
  'flex-direction-row-reverse',
  'flex-direction-column',
  'flex-direction-column-reverse',
  'flex-wrap-nowrap',
  'flex-wrap-wrap',
  'flex-wrap-wrap-reverse',
  'align-content-baseline',
  'align-content-center',
  'align-content-end',
  'align-content-flex-end',
  'align-content-flex-start',
  'align-content-normal',
  'align-content-revert',
  'align-content-space-around',
  'align-content-space-between',
  'align-content-space-evenly',
  'align-content-start',
  'align-content-stretch',
  'align-items-baseline',
  'align-items-center',
  'align-items-end',
  'align-items-flex-end',
  'align-items-flex-start',
  'align-items-normal',
  'align-items-revert',
  'align-items-self-end',
  'align-items-self-start',
  'align-items-start',
  'align-items-stretch',
  'align-self-auto',
  'align-self-baseline',
  'align-self-center',
  'align-self-end',
  'align-self-flex-end',
  'align-self-flex-start',
  'align-self-normal',
  'align-self-revert',
  'align-self-self-end',
  'align-self-self-start',
  'align-self-start',
  'align-self-stretch',
  'justify-content-center',
  'justify-content-end',
  'justify-content-flex-end',
  'justify-content-flex-start',
  'justify-content-left',
  'justify-content-normal',
  'justify-content-revert',
  'justify-content-right',
  'justify-content-space-around',
  'justify-content-space-between',
  'justify-content-space-evenly',
  'justify-content-start',
  'justify-content-stretch',
  'grid-auto-flow-row',
  'grid-row-start-auto',
  'grid-row-end-auto',
  'grid-row-start--1',
  'grid-row-end--1',
  'grid-row-span--1',
  'grid-row-start-0',
  'grid-row-end-0',
  'grid-row-span-0',
  'grid-row-start-1',
  'grid-row-end-1',
  'grid-row-span-1',
  'grid-row-start-2',
  'grid-row-end-2',
  'grid-row-span-2',
  'grid-row-start-3',
  'grid-row-end-3',
  'grid-row-span-3',
  'grid-row-start-4',
  'grid-row-end-4',
  'grid-row-span-4',
  'grid-row-start-5',
  'grid-row-end-5',
  'grid-row-span-5',
  'grid-row-start-6',
  'grid-row-end-6',
  'grid-row-span-6',
  'grid-auto-flow-column',
  'grid-column-start-auto',
  'grid-column-end-auto',
  'grid-column-start--1',
  'grid-column-end--1',
  'grid-column-span--1',
  'grid-column-start-0',
  'grid-column-end-0',
  'grid-column-span-0',
  'grid-column-start-1',
  'grid-column-end-1',
  'grid-column-span-1',
  'grid-column-start-2',
  'grid-column-end-2',
  'grid-column-span-2',
  'grid-column-start-3',
  'grid-column-end-3',
  'grid-column-span-3',
  'grid-column-start-4',
  'grid-column-end-4',
  'grid-column-span-4',
  'grid-column-start-5',
  'grid-column-end-5',
  'grid-column-span-5',
  'grid-column-start-6',
  'grid-column-end-6',
  'grid-column-span-6',
  'grid-gap-auto',
  'grid-row-gap-auto',
  'grid-column-gap-auto',
  'grid-gap-0',
  'grid-row-gap-0',
  'grid-column-gap-0',
  'grid-gap-1',
  'grid-row-gap-1',
  'grid-column-gap-1',
  'grid-gap-2',
  'grid-row-gap-2',
  'grid-column-gap-2',
  'grid-gap-3',
  'grid-row-gap-3',
  'grid-column-gap-3',
  'grid-gap-4',
  'grid-row-gap-4',
  'grid-column-gap-4',
  'grid-gap-5',
  'grid-row-gap-5',
  'grid-column-gap-5',
  'grid-gap-6',
  'grid-row-gap-6',
  'grid-column-gap-6',
  'justify-items-baseline',
  'justify-items-center',
  'justify-items-end',
  'justify-items-flex-end',
  'justify-items-flex-start',
  'justify-items-left',
  'justify-items-normal',
  'justify-items-revert',
  'justify-items-right',
  'justify-items-self-end',
  'justify-items-self-start',
  'justify-items-start',
  'justify-items-stretch',
  'justify-self-auto',
  'justify-self-baseline',
  'justify-self-center',
  'justify-self-end',
  'justify-self-flex-end',
  'justify-self-flex-start',
  'justify-self-left',
  'justify-self-normal',
  'justify-self-revert',
  'justify-self-right',
  'justify-self-self-end',
  'justify-self-self-start',
  'justify-self-start',
  'justify-self-stretch',
  'm-auto',
  'mt-auto',
  'mr-auto',
  'mb-auto',
  'ml-auto',
  'mx-auto',
  'my-auto',
  'm-0',
  'mt-0',
  'mr-0',
  'mb-0',
  'ml-0',
  'mx-0',
  'my-0',
  'm-1',
  'mt-1',
  'mr-1',
  'mb-1',
  'ml-1',
  'mx-1',
  'my-1',
  'm-2',
  'mt-2',
  'mr-2',
  'mb-2',
  'ml-2',
  'mx-2',
  'my-2',
  'm-3',
  'mt-3',
  'mr-3',
  'mb-3',
  'ml-3',
  'mx-3',
  'my-3',
  'm-4',
  'mt-4',
  'mr-4',
  'mb-4',
  'ml-4',
  'mx-4',
  'my-4',
  'm-5',
  'mt-5',
  'mr-5',
  'mb-5',
  'ml-5',
  'mx-5',
  'my-5',
  'm-6',
  'mt-6',
  'mr-6',
  'mb-6',
  'ml-6',
  'mx-6',
  'my-6',
  'p-auto',
  'pt-auto',
  'pr-auto',
  'pb-auto',
  'pl-auto',
  'px-auto',
  'py-auto',
  'p-0',
  'pt-0',
  'pr-0',
  'pb-0',
  'pl-0',
  'px-0',
  'py-0',
  'p-1',
  'pt-1',
  'pr-1',
  'pb-1',
  'pl-1',
  'px-1',
  'py-1',
  'p-2',
  'pt-2',
  'pr-2',
  'pb-2',
  'pl-2',
  'px-2',
  'py-2',
  'p-3',
  'pt-3',
  'pr-3',
  'pb-3',
  'pl-3',
  'px-3',
  'py-3',
  'p-4',
  'pt-4',
  'pr-4',
  'pb-4',
  'pl-4',
  'px-4',
  'py-4',
  'p-5',
  'pt-5',
  'pr-5',
  'pb-5',
  'pl-5',
  'px-5',
  'py-5',
  'p-6',
  'pt-6',
  'pr-6',
  'pb-6',
  'pl-6',
  'px-6',
  'py-6',
  'size-tiny',
  'size-small',
  'size-normal',
  'size-medium',
  'size-large',
  'level-1',
  'level-2',
  'level-3',
  'level-4',
  'level-5',
  'level-6',
  'weight-normal',
  'weight-strong'
]

export const baseFilter = (classes, permissive = false) =>
  permissive ? classes : classes.filter(c => helperClasses.includes(c))

export const filterClasses = (s, permissive) => baseFilter(s.split(' '), permissive)

export const updateClasses = (classes, test, c, regexp) => {
  if (regexp) classes = classes.filter(e => !regexp.test(e))
  return test ? [...classes, c] : classes.filter(e => e !== c)
}

export default filterClasses
